import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { actions } from 'react-redux-form'
import videoServices from 'services/video'
import Video from 'components/video/video'
import { mapLanguageToComponentProps } from 'i18n'
import RecorderButtons from 'components/recorder-buttons'

const propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  className: PropTypes.string,
  context: PropTypes.string.isRequired,
  isUpload: PropTypes.bool,
  video: PropTypes.shape({
    videoUrl: PropTypes.string.isRequired,
    playbackVideoUrl: PropTypes.string.isRequired,
  }).isRequired,
  onRemove: PropTypes.func,
  onVideoSubmit: PropTypes.func,
  i18n: PropTypes.shape({
    videoUpload: PropTypes.object.isRequired,
  }).isRequired,
  updateVideo: PropTypes.func,
  dispatch: PropTypes.func.isRequired,
  isEmbedded: PropTypes.bool,
}

const defaultProps = {
  children: undefined,
  className: undefined,
  isUpload: false,
  onRemove: undefined,
  onVideoSubmit: undefined,
  updateVideo: () => {},
  isEmbedded: false,
}

export class VideoDraft extends Component {
  constructor(props) {
    super(props)
    this.state = {
      state: 'pause',
      pauseVideo: false,
    }
    this.refreshPlaybackUrl = this.refreshPlaybackUrl.bind(this)
  }

  updateVideo(video) {
    const { dispatch, updateVideo } = this.props
    if (updateVideo) {
      updateVideo(video)
    } else {
      dispatch(actions.merge('video', video))
    }
  }

  removeRecording() {
    this.updateVideo({ has: false, recorder: null })
  }

  refreshPlaybackUrl(useOpentokPreview) {
    const { video } = this.props
    return videoServices.fetchPlaybackUrl(video, useOpentokPreview)
  }

  selectButtons() {
    const { isUpload } = this.props
    const { state } = this.state
    if (isUpload) {
      return 'record'
    }
    switch (state) {
      case 'play':
        return 'stop'
      case 'pause':
        return 'record'
      case 'error':
        return 'error'
      default:
        return ''
    }
  }

  renderButtons() {
    const { context, isUpload, onRemove, onVideoSubmit, video, isEmbedded } = this.props
    const { state } = this.state

    if (context === 'admin') {
      return null
    }
    // TODO is videodraft ever used if isUpload is false?
    // at least the onRecord (removeRecording) is not working (in develop either)
    return (
      <RecorderButtons
        onRecord={() => this.removeRecording()}
        onStop={() => this.setState({ pauseVideo: true })}
        button={this.selectButtons()}
        onSubmit={isUpload && onVideoSubmit}
        onRemove={onRemove}
        state={state}
        isUpload={isUpload}
        isEmbedded={isEmbedded}
        hasVideo={typeof video !== 'undefined' && video.has}
      />
    )
  }

  render() {
    const { video, isUpload, isEmbedded } = this.props
    const { state, pauseVideo } = this.state
    const className = [
      isUpload ? 'upload' : 'webcam',
      state,
      this.props.className,
    ].join(' ')

    return (
      <div className={className}>
        <div className={isUpload ? 'upload-view' : 'webcam-view'}>
          <Video
            id={video._id}
            videoUrl={video.videoUrl}
            playbackVideoUrl={video.playbackVideoUrl}
            recorder={video.recorder}
            updateState={newState =>
              this.setState({ state: newState, pauseVideo: false })
            }
            draftMode={!isUpload}
            pauseVideo={pauseVideo}
            refreshPlaybackUrl={useOpentokPreview =>
              this.refreshPlaybackUrl(useOpentokPreview)
            }
          />
        </div>
        {(!isEmbedded || (isEmbedded && state !== 'play')) &&
          this.renderButtons()}
      </div>
    )
  }
}

VideoDraft.propTypes = propTypes
VideoDraft.defaultProps = defaultProps

export default connect(mapLanguageToComponentProps())(VideoDraft)
